import swal from "sweetalert2";

const apiCallCompta_correspondance = async (setValidButton,axiosAction,obj,t,configId,setReload) => {
    if(setValidButton) setValidButton(true)

    const response = await axiosAction(process.env.REACT_APP_API_URL+"api/compta/compta_correspondance"+configId, obj
    ).then((response) => {
        if(setValidButton) setValidButton(false)
        setReload(Date.now())
    }).catch((error) => {
        if(error=='end_session') return;
        if(error.response==undefined){
            swal.fire(t('unknowError'), "", "error");
        }
        else if(error.response.status==403){
            swal.fire(t('forbiddenGeneral'), "", "error");
        }
        else {
            swal.fire(t('unknowError'), "", "error");
        }
        if(setValidButton) setValidButton(false)
    })
}

export default apiCallCompta_correspondance;